import { hasPlacedArtwork, imagesArePending } from './draftState'

export const GUIDED_STAGES = Object.freeze({
  WELCOME: 'welcome',
  PREPARING: 'preparing',
  SETUP: 'setup',
  REVIEW: 'review',
  MANUAL: 'manual',
  CHECKOUT: 'checkout',
})

const CHECKOUT_SCREENS = new Set(['summary', 'checkout'])

export function deriveGuidedStage({
  guidedBuilderEnabled,
  legacyEditReference,
  legacyResumeToken,
  manualModeRequested = false,
  workspaceEntered = false,
  uploadedImages = [],
  uploadsActive = false,
  layoutJson,
  currentScreen,
}) {
  if (!guidedBuilderEnabled) return GUIDED_STAGES.MANUAL
  if (legacyEditReference || legacyResumeToken || manualModeRequested) return GUIDED_STAGES.MANUAL
  if (CHECKOUT_SCREENS.has(currentScreen)) return GUIDED_STAGES.CHECKOUT
  if (imagesArePending(uploadedImages)) return GUIDED_STAGES.SETUP
  if (workspaceEntered) {
    return hasPlacedArtwork(layoutJson) ? GUIDED_STAGES.REVIEW : GUIDED_STAGES.SETUP
  }
  if ((uploadedImages || []).length === 0 && !uploadsActive) return GUIDED_STAGES.WELCOME
  if ((uploadedImages || []).length === 0 && uploadsActive) return GUIDED_STAGES.PREPARING
  if (hasPlacedArtwork(layoutJson)) return GUIDED_STAGES.REVIEW

  return GUIDED_STAGES.SETUP
}
